import { ArrowDownIcon, ArrowUpIcon } from '@heroicons/react/24/solid';
import { useCallback, useState } from 'react';
import { IconButton } from '@library/components/buttons/IconButton';
import type { OddsType } from '@library/types/projection';
import { OddsTypeIndicator } from '@library/components/OddsTypeIndicator';
import { cn } from '@library/component-utils/cn';

interface MoreLessButtonProps {
  onClickMore: () => void;
  onClickLess: () => void;
  oddsType: OddsType;
}

export const MoreLessButton = ({
  onClickLess,
  onClickMore,
  oddsType
}: MoreLessButtonProps) => {
  const activeBgColor = 'bg-stankonia-100 hover:bg-stankonia-100';
  const bgColor = 'bg-soFresh-100';

  const [state, setState] = useState<'more' | 'less' | undefined>();
  const handleOnClickMore = useCallback(() => {
    setState('more');
    onClickMore();
  }, [onClickMore, setState]);

  const handleOnClickLess = useCallback(() => {
    setState('less');
    onClickLess();
  }, [onClickLess, setState]);

  return (
    <div className="flex align-middle">
      {oddsType === 'standard' ? (
        <>
          <IconButton
            handleOnClick={handleOnClickMore}
            className={cn(
              'border-soFresh-140 m-0 rounded-l-md border p-2',
              state === 'more' ? activeBgColor : bgColor
            )}
          >
            <ArrowUpIcon className="text-soClean-170 size-4" />
          </IconButton>
          <IconButton
            handleOnClick={handleOnClickLess}
            className={cn(
              'border-soFresh-140 m-0 rounded-r-md border p-2',
              state === 'less' ? activeBgColor : bgColor
            )}
          >
            <ArrowDownIcon className="text-soClean-170 size-4" />
          </IconButton>
        </>
      ) : (
        <IconButton
          handleOnClick={handleOnClickMore}
          className={cn(
            'border-soFresh-140 m-0 flex w-16 items-center justify-center gap-1 rounded-md border p-2',
            state === 'more' ? activeBgColor : bgColor
          )}
        >
          <ArrowUpIcon className="text-soClean-170 size-4" />
          <OddsTypeIndicator oddsType={oddsType} className="size-3" />
        </IconButton>
      )}
    </div>
  );
};
